// extracted by mini-css-extract-plugin
export default {"wrapNoBreak":"MBCSearchPage__wrapNoBreak___dA1O6","meritBadgesList":"MBCSearchPage__meritBadgesList___m3Njt","editIcon":"MBCSearchPage__editIcon___QngHK"};